/**
 * @file header.class.js
 * @description Defines the Header class.
 */

class Header {
  constructor(debug = false) {
    this.elHeader = Helper.getElement('header.header');
    this.elBanner = Helper.getElement('.banner');
    this.elInnerBanner = Helper.getElement('.inner-banner');
    this.viewportWidth = window.innerWidth;
    this.addPlaceholder = Helper.debounce( (event) => { this.addPlaceholderFn(event) }, 300);
    this.init();
    this.debug();
  }

  init() {
    this.bindEvents();
    this.addPlaceholder();
    this.handleStickyHeader(); // Initial check
  }

  bindEvents() {
    window.addEventListener('scroll', () => { this.handleStickyHeader(); });
    window.addEventListener('resize', (event) => { this.addPlaceholder(event) });
  }

  /**
   * @description Check if the user has scrolled past the header. If they have
   * add the is-sticky class.
   */
  handleStickyHeader() {
    let offsetTop = window.pageYOffset;
    let headerHeight = this.elHeader?.getBoundingClientRect().height || 0;;
    let headerOffset = this.elHeader.offsetTop;
    let threshold = headerHeight + headerOffset;

    if (offsetTop > threshold) {
      this.elHeader.classList.add('is-sticky');
    } else {
      this.elHeader.classList.remove('is-sticky');
    }

  }

  /**
   * @description Adds a placeholder in the headers position with the same height as the header.
   */
  addPlaceholderFn(event = null) {
    let elPlaceholder = document.querySelector('.header-placeholder');
    let headerHeight = 0;
    let viewportWidth = window.innerWidth;
    
    // If the header has the is-sticky class already applied, remove it temporarily and calculate the height.
    if (this.elHeader.classList.contains('is-sticky')) {
      this.elHeader.classList.remove('is-sticky');
      headerHeight = this.elHeader?.getBoundingClientRect().height || 0;
      this.elHeader.style["-webkit-animation-duration"] = "0s";
      this.elHeader.classList.add('is-sticky');

      setTimeout( () => {
        this.elHeader.style["-webkit-animation-duration"] = "";
      }, 750);
    } else {
      headerHeight = this.elHeader?.getBoundingClientRect().height || 0;
    }


    // On mobile when the navigation is hidden a resize event is triggered. To bypass this we need to make sure
    // this is only checking if the x-axis of the viewport has changed.
    if (elPlaceholder && viewportWidth != this.viewportWidth) {
      this.viewportWidth = viewportWidth;
      elPlaceholder.style.height = headerHeight + 'px';
      return;
    }

    let elHeaderParent = this.elHeader.parentElement;
    let isDNNEditState = document.body.classList.contains('dnnEditState');

    if (this.elHeader.dataset.placeholder && !isDNNEditState && !elPlaceholder) {

      let elPlaceholder = document.createElement('div');
      elPlaceholder.classList.add('header-placeholder');
      elPlaceholder.style.height = headerHeight + 'px';

      /*
      if (this.elBanner || this.elInnerBanner) { elHeaderParent.insertBefore(elPlaceholder, this.elHeader); }
      */
      elHeaderParent.insertBefore(elPlaceholder, this.elHeader);
      
    }
  }

  /**
   * @description Adds a top margin to the content pane below.
   */
  addMarginBelow() {
    let headerHeight = Helper.getHeight(this.elHeader);
    let isDNNEditState = document.body.classList.contains('dnnEditState');

    if (this.elHeader.dataset.marginBelow && !isDNNEditState) {

      if (this.elBanner) { this.elBanner.style.marginTop = headerHeight + 'px'; }
      if (this.elInnerBanner) { this.elInnerBanner.style.marginTop = headerHeight + 'px'; }
      
    }
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c Header', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}